import { Table, TableHead, TableCell, TableRow, TableBody } from "@mui/material";

interface SeniorMatrixProps {
  tortuga?: boolean;
  hasRos?: boolean;
}

const SeniorMatrix = ({ tortuga, hasRos }: SeniorMatrixProps) => {

  return (
    <div>
      <Table className="matrix-table">
        <TableHead>
          <TableCell colSpan={4} align="center">
            <h4>Senior Officer Review Matrix</h4>
          </TableCell>
        </TableHead>
        <TableHead>
          <TableRow>
            <TableCell>Review</TableCell>
            <TableCell>1st Assessor</TableCell>
            <TableCell>2nd Assessor</TableCell>
            <TableCell>Reviewer</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tortuga ? (
            <>
              <TableRow>
                <TableCell className="b-600">Master</TableCell>
                <TableCell>Director of LNG Ops</TableCell>
                <TableCell>VP</TableCell>
                <TableCell>President</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="b-600">Chief Engineer</TableCell>
                <TableCell>Master</TableCell>
                <TableCell>Director of LNG Ops</TableCell>
                <TableCell>VP</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="b-600">Mate</TableCell>
                <TableCell>Master</TableCell>
                <TableCell>Director of LNG Ops</TableCell>
                <TableCell>VP</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="b-600">1st AE</TableCell>
                <TableCell>Master</TableCell>
                <TableCell>Director of LNG Ops</TableCell>
                <TableCell>VP</TableCell>
              </TableRow>
            </>
          ) : (
            <>
              <TableRow>
                <TableCell className="b-600">Master</TableCell>
                <TableCell>DSM</TableCell>
                <TableCell>VP</TableCell>
                <TableCell>President</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="b-600">Chief</TableCell>
                <TableCell>Master</TableCell>
                <TableCell>DSM</TableCell>
                <TableCell>VP</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="b-600">CM</TableCell>
                <TableCell>Master</TableCell>
                <TableCell>DSM</TableCell>
                <TableCell>VP</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="b-600">1st AE</TableCell>
                <TableCell>Chief Engineer</TableCell>
                <TableCell>Master</TableCell>
                <TableCell>DSM</TableCell>
              </TableRow>
            </>
          )}
        </TableBody>
      </Table>

      {hasRos && (
        <div style={{ marginTop: "30px" }}>
          <Table className="matrix-table">
            <TableHead>
              <TableCell colSpan={4} align="center">
                <h4>ROS Senior Officer Review Matrix</h4>
              </TableCell>
            </TableHead>
            <TableHead>
              <TableRow>
                <TableCell>Review</TableCell>
                <TableCell>1st Assessor</TableCell>
                <TableCell>2nd Assessor</TableCell>
                <TableCell>Reviewer</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell className="b-600">Chief</TableCell>
                <TableCell>Port Engineer</TableCell>
                <TableCell>DSM</TableCell>
                <TableCell>VP</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="b-600">CM</TableCell>
                <TableCell>Port Engineer</TableCell>
                <TableCell>DSM</TableCell>
                <TableCell>VP</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="b-600">1st AE</TableCell>
                <TableCell>Chief Engineer</TableCell>
                <TableCell>Port Engineer</TableCell>
                <TableCell>DSM</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default SeniorMatrix;
